import React from "react";
import { CourseFromGroupApi } from "api";
import { PaziaModal } from "components/molecules";
import { ModalPadding } from "../Modals/ModalPadding";
import { CategoryFormGroupForm, CategoryFormGroupSchema } from "./CategoryFormGroupForm";

interface AddCategoryFormGroupModalProps {
  onCloseRequest: () => void;
  onSubmit: (data: CategoryFormGroupSchema) => Promise<void>;
  group: CourseFromGroupApi | null;
}

export const AddCategoryFormGroupModal = ({ onCloseRequest, group, onSubmit }: AddCategoryFormGroupModalProps) => {
  return (
    <PaziaModal id="add-category-form-group-modal" onCloseRequest={onCloseRequest} isOpen={!!group} size="2xl">
      <ModalPadding>
        <div className="text-xl">
          <div className="mb-2 font-medium text-slate-800 dark:text-slate-100">
            {group?.courseFormGroupId ? "Edycja grupy" : "Dodaj nową grupę domyślną"}
          </div>
        </div>
        {group && <CategoryFormGroupForm group={group} onSubmit={onSubmit} onCancel={onCloseRequest} />}
      </ModalPadding>
    </PaziaModal>
  );
};
